import { Icon } from '@components/abb-icon/icons';
import { Report_Category } from 'gql/graphql';

type ReportTemplate = {
  icon: Icon;
  title: string;
  description: string;
  defaultTemplate: boolean;
};
export type CATEGORY = Record<Report_Category | string, ReportTemplate>;
export const REPORT_CATEGORY_DICTIONARY = {
  // [Report_Category.Sustainability]: {
  //   icon: 'mat-outlined/solar_power' as Icon,
  //   title: 'ESG Report',
  //   description: 'Monthly sustainability performance ',
  //   defaultTemplate: false,
  // },
  [Report_Category.EnergyConsumption]: {
    icon: 'mat/query_stats' as Icon,
    title: 'Energy Report',
    description: 'Key highlights of energy performance for properties within a selected time period.',
    defaultTemplate: true,
  },
  [Report_Category.CostAnalysis]: {
    icon: 'mat/query_stats' as Icon,
    title: 'Cost Report',
    description: 'Key highlights of cost-related metrics for properties within a selected time period.',
    defaultTemplate: true,
  },
  [Report_Category.Historical]: {
    icon: 'mat/history' as Icon,
    title: 'Historical',
    description: 'Data export for given interval.',
    defaultTemplate: false,
  },
  [Report_Category.AlarmlogsExport]: {
    icon: 'mat/history' as Icon,
    title: 'Alarm Logs',
    description: 'Data export for given interval.',
    defaultTemplate: false,
  },
  [Report_Category.BenchmarkExport]: {
    icon: 'mat/history' as Icon,
    title: 'Benchmark',
    description: 'Data export for given interval.',
    defaultTemplate: false,
  },
  [Report_Category.DashboardExport]: {
    icon: 'mat/history' as Icon,
    title: 'Dashboard',
    description: 'Data export for given interval.',
    defaultTemplate: false,
  },
  [Report_Category.DeviceEventExport]: {
    icon: 'mat/history' as Icon,
    title: 'Device Events',
    description: 'Data export for given interval.',
    defaultTemplate: false,
  },
  // [Report_Category.General]: {
  //   icon: 'mat-outlined/admin_panel_settings' as Icon, // MEMO: icona corretta non trovata
  //   title: 'Internal',
  //   description: 'Useful for sharing insights with an internal audience',
  //   defaultTemplate: false,
  // },
};
